module.exports = __webpack_public_path__ + "media/img/patterns/topographic-pattern-light-a8d7653077c78b783f735605b1cf22d8.png";